import { useMemo } from 'react';

import { useProductWizardContext } from 'features/menu/components/product-wizard';

import { ILocalizedMenuEntry } from 'state/unified-menu/types';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { getComboSlotDefaultItem, isCombo } from 'state/unified-menu/utils';

/**
 * Items representing the current combo selection: one per slot, falling back to
 * slot defaults before the guest reaches the slot steps. Empty for non-combos.
 */
export const useComboNutritionItems = (): ILocalizedMenuEntry[] => {
  const { slotsSelections, selectedProduct } = useProductWizardContext();
  const { indexedMenu } = useUnifiedMenuContext();

  return useMemo(() => {
    if (!selectedProduct || !isCombo(selectedProduct)) {
      return [];
    }

    if (Object.keys(slotsSelections).length > 1) {
      return Object.values(slotsSelections)
        .map(comboSlot => indexedMenu.find(comboSlot?.itemId!))
        .filter(Boolean) as ILocalizedMenuEntry[];
    }

    return (selectedProduct.options?.defaults || [])
      .map(defaultItemId => {
        try {
          return getComboSlotDefaultItem(indexedMenu, defaultItemId);
        } catch {
          return undefined;
        }
      })
      .filter(Boolean) as ILocalizedMenuEntry[];
  }, [indexedMenu, selectedProduct, slotsSelections]);
};
